(function() {
  if (customElements.get('walk-fit-finder')) return;
  const sizeRequests = new Map();
  function loadSizes(url) {
    if (!sizeRequests.has(url)) {
      sizeRequests.set(url, fetch(url).then(r => {
        if (!r.ok) throw new Error('Size information unavailable');
        return r.json();
      }).catch(error => { sizeRequests.delete(url); throw error; }));
    }
    return sizeRequests.get(url);
  }
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function rangeText(row, strings) {
    return ['neck','chest'].filter(d => row[d]).map(d => strings[d] + ': ' + row[d].join('–') + ' cm').join(' · ');
  }
  class FitFinder extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.form = this.querySelector('form');
      this.status = this.querySelector('[data-fit-status]');
      this.results = this.querySelector('[data-fit-results]');
      this.grid = this.querySelector('[data-fit-grid]');
      this.clearButton = this.querySelector('[data-fit-clear]');
      this.moreButton = this.querySelector('[data-fit-more]');
      this.submitButton = this.form.querySelector('[type="submit"]');
      this.strings = JSON.parse(this.querySelector('[data-fit-strings]').textContent);
      this.sequence = 0;
      this.form.addEventListener('submit', event => { event.preventDefault(); this.search(); });
      this.clearButton.addEventListener('click', () => this.clear());
      this.moreButton.addEventListener('click', () => this.renderMore());
      const params = new URLSearchParams(location.search);
      for (const dimension of ['neck','chest']) {
        const field = this.form.elements[dimension];
        if (field && params.has('fit_' + dimension)) field.value = params.get('fit_' + dimension);
      }
      if (this.form.elements[this.dataset.kind === 'collar' ? 'neck' : 'chest'].value && this.form.checkValidity()) this.search();
    }
    standard() { return document.getElementById(this.dataset.standard); }
    clear() {
      this.sequence++;
      this.form.reset();
      this.submitButton.disabled = false;
      this.status.textContent = '';
      this.results.hidden = true;
      this.clearButton.hidden = true;
      this.standard().hidden = false;
      const url = new URL(location.href);
      url.searchParams.delete('fit_neck');
      url.searchParams.delete('fit_chest');
      history.replaceState({}, '', url);
    }
    async catalogue() {
      const products = new Map();
      let url = new URL(location.href);
      for (const key of ['page','fit_neck','fit_chest','filter.v.option.size','section_id']) url.searchParams.delete(key);
      for (let page = 0; page < 20; page++) {
        url.searchParams.set('section_id','fit-catalog');
        const response = await fetch(url);
        if (!response.ok) throw new Error('Catalogue unavailable');
        const html = await response.text();
        const script = new DOMParser().parseFromString(html,'text/html').querySelector('[data-fit-catalog]');
        if (!script) throw new Error('Catalogue unavailable');
        const result = JSON.parse(script.textContent);
        result.products.forEach(product => products.set(product.id,product));
        if (!result.next) return [...products.values()];
        url = new URL(result.next, location.href);
      }
      throw new Error('Catalogue incomplete');
    }
    async search() {
      if (!this.form.reportValidity()) return;
      const sequence = ++this.sequence;
      this.measures = {};
      const url = new URL(location.href);
      for (const dimension of ['neck','chest']) {
        const value = this.form.elements[dimension]?.value;
        const measure = value ? Number(value) : null;
        this.measures[dimension] = measure;
        if (measure != null) url.searchParams.set('fit_' + dimension, measure);
        else url.searchParams.delete('fit_' + dimension);
      }
      history.replaceState({}, '', url);
      this.status.textContent = this.strings.loading;
      this.submitButton.disabled = true;
      this.clearButton.hidden = false;
      this.results.hidden = true;
      this.setAttribute('aria-busy','true');
      try {
        const [database, products] = await Promise.all([loadSizes(this.dataset.sizes),this.catalogue()]);
        if (sequence !== this.sequence) return;
        this.matches = products.flatMap(product => {
          const matches = MarkedFit.matches(product,database,this.measures);
          return matches.length ? [{product,matches}] : [];
        });
        this.status.textContent = this.matches.length ? this.strings.count.replace('[count]',this.matches.length) : this.strings.empty;
        this.standard().hidden = true;
        this.results.hidden = false;
        this.grid.replaceChildren();
        this.rendered = 0;
        this.renderMore();
      } catch (error) {
        if (sequence !== this.sequence) return;
        this.status.textContent = this.strings.error;
        this.standard().hidden = false;
        this.results.hidden = true;
      } finally {
        if (sequence === this.sequence) {
          this.submitButton.disabled = false;
          this.removeAttribute('aria-busy');
        }
      }
    }
    productUrl(product, variant) {
      const url = new URL(product.url,location.origin);
      url.searchParams.set('variant',variant.id);
      for (const dimension of ['neck','chest']) if (this.measures[dimension] != null) url.searchParams.set('fit_' + dimension,this.measures[dimension]);
      return url.href;
    }
    renderMore() {
      const next = this.matches.slice(this.rendered,this.rendered + 24);
      for (const {product,matches} of next) {
        const match = matches[0];
        const item = element('li','fit-finder__card');
        const link = element('a');
        link.href = this.productUrl(product,match.variant);
        if (product.image) {
          const media = element('span','fit-finder__image');
          const image = element('img');
          image.src = product.image;
          image.width = 600;
          image.height = 600;
          image.alt = product.title;
          image.loading = 'lazy';
          media.append(image);
          link.append(media);
        }
        link.append(element('p','fit-finder__brand',product.vendor),element('h3','',product.title),element('p','fit-finder__price',match.variant.price),element('p','fit-finder__size',this.strings.size + ': ' + match.row.label),element('p','fit-finder__range',rangeText(match.row,this.strings)));
        if (match.status !== 'verified') {
          const notice = this.strings[match.status].replace('[opening]',match.row.opening ?? '');
          link.append(element('p','fit-finder__check',notice));
        }
        item.append(link);
        if (matches.length > 1) {
          const alternatives = element('div','fit-finder__alternatives');
          alternatives.append(element('span','',this.strings.also_fits));
          for (const alternative of matches.slice(1)) {
            const option = element('a','',alternative.row.label);
            option.href = this.productUrl(product,alternative.variant);
            alternatives.append(option);
          }
          item.append(alternatives);
        }
        this.grid.append(item);
      }
      this.rendered += next.length;
      this.moreButton.hidden = this.rendered >= this.matches.length;
    }
  }
  class FitProduct extends HTMLElement {
    async connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.wrapper = this.closest('.walk-lab');
      this.note = this.querySelector('[data-fit-product-note]');
      this.strings = JSON.parse(this.querySelector('[data-fit-strings]').textContent);
      try {
        const database = await loadSizes(this.dataset.sizes);
        this.family = database.families[this.dataset.family];
        if (!this.family) return;
        this.wrapper.querySelectorAll('input[type="radio"][name="Size"]').forEach(input => {
          const label = this.wrapper.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          if (label) {
            const size = MarkedFit.normalise(input.value);
            const row = this.family.sizes[size];
            label.textContent = row?.label || size;
            if (row && !/^SIZE\d+$/.test(size)) {
              const dimension = this.family.kind === 'harness' ? 'chest' : 'neck';
              const range = row[dimension];
              if (range) label.append(element('span','fit-size-range',this.strings[dimension] + ' ' + range.join('–') + ' cm'));
            }
          }
        });
        this.wrapper.querySelectorAll('select[name="options[Size]"] option').forEach(option => {
          const size = MarkedFit.normalise(option.value);
          const row = this.family.sizes[size];
          option.textContent = row?.label || size;
          const dimension = this.family.kind === 'harness' ? 'chest' : 'neck';
          const range = row?.[dimension];
          if (range && !/^SIZE\d+$/.test(size)) option.textContent += ' · ' + this.strings[dimension] + ' ' + range.join('–') + ' cm';
        });
        this.wrapper.addEventListener('change',() => this.update());
        this.update();
      } catch (error) { this.note.hidden = true; }
    }
    update() {
      const value = this.wrapper.querySelector('input[type="radio"][name="Size"]:checked')?.value || this.wrapper.querySelector('select[name="options[Size]"]')?.value;
      if (!value) return;
      const row = this.family.sizes[MarkedFit.normalise(value)];
      this.note.hidden = false;
      if (!row) { this.note.textContent = this.strings.check_guide; return; }
      const parts = [rangeText(row,this.strings)].filter(Boolean);
      if (row.opening != null) parts.push(this.strings.opening.replace('[opening]',row.opening));
      if (row.maximum != null) parts.push(this.strings.maximum.replace('[maximum]',row.maximum));
      this.note.textContent = parts.join(' · ');
    }
  }
  customElements.define('walk-fit-finder',FitFinder);
  customElements.define('walk-fit-product',FitProduct);
  document.addEventListener('click',event => {
    const link = event.target.closest('[data-walk-choice]');
    if (!link) return;
    const current = new URL(location.href);
    const destination = new URL(link.href);
    for (const dimension of ['neck','chest']) {
      const value = Number(current.searchParams.get('fit_' + dimension));
      if (value > 0 && value <= 180) destination.searchParams.set('fit_' + dimension,value);
    }
    link.href = destination.href;
  });
})();
